import Color from 'color';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import {
    IElementNode,
    ITextElementBoxNode,
} from '@src/slide/application/service/slide-rating-and-improve/slide-content-analyzer.interface';

export const UnknownColor = 'UNKNOWN_COLOR' as const;
export type BackColor = Color | typeof UnknownColor;

interface ImageInfo {
    src: string;
}

export enum ColorBackType {
    SLIDE_BACKGROUND, // 页面背景（目前主要处理纯色填充）
    ELEMENT, // 元素（目前主要处理Shape的纯色填充）
    TEXT_BACK, // 文字（主要指的是文字背景色）
}

// 文字背景基类
export interface ITextColorBack {
    type: ColorBackType;
    color: BackColor;
    image?: ImageInfo;
}

// 页面背景色
export interface ISlideBack extends ITextColorBack {
    type: ColorBackType.SLIDE_BACKGROUND;
    slideModel: ISlideModel;
}

// 文字所在图形背景色
export interface IElementBack extends ITextColorBack {
    type: ColorBackType.ELEMENT;
    elementNode: IElementNode;
}

// 文字本身的背景色
export interface ITextElementBack extends ITextColorBack {
    type: ColorBackType.TEXT_BACK;
    textElementNode: ITextElementBoxNode;
}

export enum TextColoContrastRule {
    // 字号小与18的文字背景规则，对比度需要大于3.5
    small,
    // 字号18到50之间的文字背景规则，对比度大于2.8即可
    normal,
    // 字号50到100之间的文字背景规则，对比度大于2即可
    larger,
    // 字号大于100的文字背景规则，对比度大于1.5即可
    largest,
}

export interface IColorAnalysisTask {
    boxNode: ITextElementBoxNode;
    textColor: Color;
    textBack: ITextColorBack & { color: Color };
}

export interface IColorAnalysisResult {
    boxNode: ITextElementBoxNode,
    textColor: BackColor,
    textBack: ITextColorBack,
    contrast: number,
    textFontSize?: number,
    contrastRule?: TextColoContrastRule,
    ratio?: number,
}
